import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@edil/ui/styles.css';
// Same self-hosted fonts as the player app.
import '../../web/src/fonts.css';
import './admin.css';
import { App } from './App';
import { AppProvider } from '@/lib/app';
import { RouterProvider } from '@/router';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider>
      <AppProvider>
        <App />
      </AppProvider>
    </RouterProvider>
  </StrictMode>,
);
